(() => {
  const hdr = document.querySelector('[data-hdr]');
  const onScroll = () => hdr && hdr.classList.toggle('is-solid', window.scrollY > 40);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.getElementById('drawer');
  if (toggle && drawer) {
    const set = (open) => {
      drawer.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? 'Close' : 'Menu';
      document.body.classList.toggle('menu-open', open);
    };
    toggle.addEventListener('click', () => set(drawer.hidden));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) { set(false); toggle.focus(); } });
  }

  document.querySelectorAll('form.buy').forEach((form) => {
    const json = form.querySelector('[data-variants]');
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = form.querySelector('input[name="id"]');
    const sets = [...form.querySelectorAll('.opt')];
    const buttons = [...form.querySelectorAll('[data-add]'), ...document.querySelectorAll('[data-add][form="' + form.id + '"]')];
    const prices = document.querySelectorAll('[data-price="' + form.id + '"]');

    if (sets.length === 1) {
      sets[0].querySelectorAll('.pill').forEach((pill) => {
        const val = pill.querySelector('input').value;
        const v = variants.find((x) => x.options[0] === val);
        pill.classList.toggle('is-out', !v || !v.available);
      });
    }

    form.addEventListener('change', (e) => {
      if (!e.target.closest('.opt')) return;
      const chosen = sets.map((s) => { const c = s.querySelector('input:checked'); return c ? c.value : null; });
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      buttons.forEach((b) => {
        b.disabled = !v || !v.available;
        b.textContent = !v ? 'Unavailable' : v.available ? b.dataset.label : b.dataset.sold;
      });
      if (!v) return;
      idInput.value = v.id;
      prices.forEach((p) => { p.innerHTML = v.price; });
      if (form.dataset.sync === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url);
      }
    });
  });

  const sticky = document.querySelector('[data-sticky]');
  const anchor = document.querySelector('.pdp [data-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(anchor);
  }
})();